var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.05039 11.2957L5.10781 11.2465L9.38711 7.52773C9.53203 7.40195 9.62227 7.21328 9.62227 7.00273C9.62227 6.79219 9.5293 6.60352 9.38711 6.47773L5.11602 2.76172L5.04492 2.69883C4.97656 2.65234 4.89453 2.625 4.80703 2.625C4.56914 2.625 4.375 2.82734 4.375 3.07891L4.375 10.9211C4.375 11.1727 4.56914 11.375 4.80703 11.375C4.89727 11.375 4.98203 11.3449 5.05039 11.2957Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/Right.77503350.svg";
export { ForwardRef as ReactComponent };